<h2 mat-dialog-title>Ubah Password</h2>
<mat-dialog-content class="mat-typography">
    <form class="form-container" name="form" (ngSubmit)="f.form.valid && onSubmit()" #f="ngForm" novalidate>
        <p>
            <mat-form-field appearance="outline">
                <mat-label>Password Lama</mat-label>
                <input matInput [type]="hidePassword ? 'password' : 'text'" [formControl]="oldPassword" />
                <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword"
                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword">
                    <mat-icon>{{
                        hidePassword ? "visibility_off" : "visibility"
                        }}</mat-icon>
                </button>
                <mat-error *ngIf="oldPassword.invalid">{{
                    getPasswordErrorMessage()
                    }}</mat-error>
            </mat-form-field>
        </p>
        <p>
            <mat-form-field appearance="outline">
                <mat-label>Password Baru</mat-label>
                <input matInput [type]="hidePassword ? 'password' : 'text'" [formControl]="password" />
                <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword"
                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword">
                    <mat-icon>{{
                        hidePassword ? "visibility_off" : "visibility"
                        }}</mat-icon>
                </button>
                <mat-error *ngIf="password.invalid">{{
                    getPasswordErrorMessage()
                    }}</mat-error>
            </mat-form-field>
        </p>
        <p>
            <mat-form-field appearance="outline">
                <mat-label>Ketik Ulang Password</mat-label>
                <input matInput [type]="hidePassword ? 'password' : 'text'" [formControl]="retypePassword" />
                <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword"
                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword">
                    <mat-icon>{{
                        hidePassword ? "visibility_off" : "visibility"
                        }}</mat-icon>
                </button>
                <mat-error *ngIf="retypePassword.invalid">{{
                    getPasswordErrorMessage()
                    }}</mat-error>
            </mat-form-field>
        </p>
        <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close>Batal</button>
    <button mat-raised-button cdkFocusInitial color="primary" *ngIf="!isLoading" (click)="f.form.valid && onSubmit()">
        Simpan
    </button>
</mat-dialog-actions>